<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>政策法规</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs type="border-card">
      <el-tab-pane label="法律法规">
        <ul class="news-list">
          <li class="news-list-item" v-for="(item,index) in policyList1" :key="index">
            <router-link to="/newsDetail" class="news-list_link" :title="item.title">
              <span class="news-list_title">{{item.title}}</span>
              <span class="news-list_date">{{item.date}}</span>
            </router-link>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="安全技术规范">
        <ul class="news-list">
          <li class="news-list-item" v-for="(item,index) in policyList2" :key="index">
            <router-link to="/newsDetail" class="news-list_link" :title="item.title">
              <span class="news-list_title">{{item.title}}</span>
              <span class="news-list_date">{{item.date}}</span>
            </router-link>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="规范性文件">
        <ul class="news-list">
          <li class="news-list-item" v-for="(item,index) in policyList3" :key="index">
            <router-link to="/newsDetail" class="news-list_link" :title="item.title">
              <span class="news-list_title">{{item.title}}</span>
              <span class="news-list_date">{{item.date}}</span>
            </router-link>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="地方法规">
        <ul class="news-list">
          <li class="news-list-item" v-for="(item,index) in policyList4" :key="index">
            <router-link to="/newsDetail" class="news-list_link" :title="item.title">
              <span class="news-list_title">{{item.title}}</span>
              <span class="news-list_date">{{item.date}}</span>
            </router-link>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
    <!-- 分页 -->
    <div class="page-pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="1000">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      policyList1:[
        {
          title: '特种设备安全监督检查办法（国家市场监督管理总局第57号令）',
          date: '2022-05-25'
        },
        {
          title: '特种设备事故报告和调查处理规定（国家市场监督管理总局第50号令）',
          date: '2022-01-28'
        },
        {
          title: '特种设备作业人员监督管理办法（国家质检总局第140号令）',
          date: '2021-06-25'
        },
        {
          title: '大型游乐设施安全监察规定（国家质检总局第154号令）',
          date: '2021-04-22'
        },
        {
          title: '客运索道安全监督管理规定（国家质检总局第179号令）',
          date: '2020-11-03'
        }
      ],
      policyList2:[
        {
          title: '压力管道元件型式试验规则（TSG D7002—2023）',
          date: '2023-07-14'
        },
        {
          title: '电梯自行检测规则(TSG T7008-2023)',
          date: '2023-04-07'
        },
        {
          title: '电梯监督检验和定期检验规则(TSG T7001-2023)',
          date: '2023-04-07'
        },
        {
          title: '压力管道定期检验规则—长输管道（TSG D7003—2022）',
          date: '2022-12-30'
        },
        {
          title: '特种设备检验人员考核规则（TSG Z8002-2022）',
          date: '2022-08-05'
        }
      ],
      policyList3:[
        {
          title: '市场监管总局办公厅关于加快推进全国气瓶质量安全追溯体系建设的通知（市监特设〔2019〕69号）',
          date: '2019-12-09'
        },
        {
          title: '市场监管总局办公厅关于特种设备行政许可有关事项的实施意见（市监特设〔2019〕32号）',
          date: '2019-05-27'
        },
        {
          title: '市场监管总局关于特种设备行政许可优化准入服务和加强事中事后监管措施的公告（2019年第8号）',
          date: '2019-02-18'
        },
        {
          title: '市场监管总局办公厅关于规范压力容器安全技术有关要求的通知（市监特设函〔2019〕195号）',
          date: '2019-01-29'
        },
        {
          title: '市场监管总局关于特种设备行政许可有关事项的公告（2019年第3号）',
          date: '2019-01-16'
        }
      ],
      policyList4:[
        {
          title: '包头市市场监督管理局（知识产权局） 关于申报2021、2022年度第三批 知识产权奖励项目的通知',
          date: '2023-11-02'
        },
        {
          title: '包头市市场监督管理局关于印发 开展市场主体除名试点工作的通知',
          date: '2023-09-28'
        },
        {
          title: '关于印发《包头市推动知识产权高质量发展年度工作方案（2023）》的通知',
          date: '2023-09-28'
        },
        {
          title: '包头市市场监督管理局（知识产权局）关于印发《包头市中小微企业知识产权托管工作方案》的通知',
          date: '2023-09-27'
        },
        {
          title: '包头市市场监督管理局（知识产权局）关于运用区块链技术加强数据知识产权保护工作的通知',
          date: '2023-09-26'
        }
      ],
    }
  },
  methods: {
   
  },
  computed: {
   
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newsList.vue